import React, { useState, useEffect, Fragment } from 'react'
import './AddOrEditAgent.css';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { getInstitutionsCategoriesCreated, getAgent, getRoles, getAgents, updateAgent, addAgent, getInstitutionsOfCategory } from '../../services/http';
import { useNavigate, useParams } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import Navbar from '../../appShell/Navbar/Navbar';
import Select, { StylesConfig } from 'react-select';
import { FiEye } from "react-icons/fi"
import { AiFillEyeInvisible } from "react-icons/ai";
import Loader from '../Loader/Loader';
import ProcessSpinner from '../ProcessSpinner/ProcessSpinner';


const AddOrEditAgent = (props) => {

    const { operationType } = props;

    const navigate = useNavigate();

    const id_agent = useParams()

    const [agent, setAgent] = useState({ nom: "", poste: "", prenom: "", sexe: { label: "", value: "" }, telephone: "", email: "", categorieInstitution: { label: "", value: "" }, institution: { label: "", value: "" }, password: "", type: { label: "", value: "" }, roles: [], isBCC: { label: "", value: "" } });

    const [institutionCategories, setInstitutionCategories] = useState([]);
    const [displayLoader, setDisplayLoader] = useState(operationType == "new" ? false : true);
    const [processOngoing, setProcessOngoing] = useState(false)


    const [institutionsOfCategory, setInstitutionsOfCategory] = useState([]);
    // const [isBCC, setIsBCC] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [roles, setRoles] = useState([{ value: "", label: "" }]);
    const [rolesCopy, setRolesCopy] = useState([{ value: "", label: "" }]);


    const sexAgent = [
        { value: "M", label: "Masculin" },
        { value: "F", label: "Féminin" }
    ]

    const isBCC = [
        { value: 0, label: "NON" },
        { value: 1, label: "OUI" }
    ]

    const typeAgent = [
        { label: "directeur", value: "directeur" },
        { label: "agent", value: "agent" }
    ]

    const styles = {
        fontSize: 14,
        color: 'blue',
        height: 35
    }

    // To populate the breadcrumb and update the sidebar menu
    useEffect(() => {
        let type;
        if (operationType == "new") { type = "Ajout" } else { type = "Modification" }
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Agents", secondLevelLink: "/agent", thirdLevelText: type, thirdLevelLink: ""
            }
        });
        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("users", dispatch)
    }, [])

    const [defaultRoles, setDefaultRoles] = useState()

    const handleDisplayPassword = () => {
        if (showPassword === true) {
            setShowPassword(false)
        } else {
            setShowPassword(true)
        }
    }

    const loadAgentData = async () => {
        const resp = await getAgent(id_agent, states.userToken.access_token)
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data ", resp.data)
            let data_received = resp.data;
            console.log("Data of Agent  ", data_received)
            const newData = resp.data?.agent?.roles?.map(value => ({
                value: value.id,
                label: value.name,

            }))
            var agent_info = data_received.agent;
            var sexAgentLabel = data_received.agent.sexe === "M" ? "Masculin" : "Féminin"
            var isBccAgentLabel = data_received.agent.isBcc === 1 ? "OUI" : "NON"

            // setRoles(newData)
            setAgent({
                ...agent, nom: agent_info.nom,
                poste: agent_info.poste,
                prenom: agent_info.prenom,
                sexe: { value: agent_info.sexe, label: sexAgentLabel },
                telephone: data_received.agent.telephone,
                email: data_received.agent.email,
                categorieInstitution: { value: agent_info.institution?.category_institution?.id, label: agent_info.institution?.category_institution?.libelle },
                institution: { value: agent_info.institution?.id, label: agent_info.institution?.libelle },
                password: data_received.agent.password,
                type: { value: agent_info.type_agent, label: agent_info.type_agent },
                roles: newData,
                isBCC: { value: agent_info.isBcc, label: isBccAgentLabel }
            })
            setDisplayLoader(false)
        }


    }

    useEffect(() => {
        if (agent.institution.label == "BCC") {
            setAgent({ ...agent, isBCC: { value: 1, label: "OUI" } })
        } else {
            setAgent({ ...agent, isBCC: { value: 0, label: "NON" } })
        }

    }, [agent.institution]);


    const loadInstitutionCategories = async () => {
        const resp = await getInstitutionsCategoriesCreated(states.userToken.access_token);
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data ", resp.data)
            const newData2 = resp.data?.categoryInstitutions?.map(value => ({
                value: value.id,
                label: value.libelle,
            }))

            setInstitutionCategories(newData2)
        }
    }

    const loadInstitutions = async (idCategory) => {
        console.log(idCategory)
        const resp = await getInstitutionsOfCategory(idCategory, states.userToken.access_token);
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data ", resp.data)

            const newData = resp.data?.map(value => ({
                value: value.id,
                label: value.libelle,
            }))

            setInstitutionsOfCategory(newData)
        }
    }

    const loadRoles = async () => {
        const resp = await getRoles(states.userToken.access_token);
        if (resp.response && resp.response.status !== 200) {
            console.log("data data roles data error ", resp.response)
        } else {
            console.log("data data roles ", resp.data)

            const newData = resp.data.map(value => ({
                value: value.id,
                label: value.name,

            }))
            setRoles(newData)
            setRolesCopy(newData)
        }
    }

    useEffect(() => {
        loadInstitutions(agent.categorieInstitution.value);
        console.log("Doing")
    }, [agent.categorieInstitution])




    const [showErrorNom, setShowErrorNom] = useState(false)
    const [showErrorPrenom, setShowErrorPrenom] = useState(false)
    const [showErrorEmail, setShowErrorEmail] = useState(false)
    const [showErrorTelephone, setShowErrorTelephone] = useState(false)
    const [showErrorPoste, setShowErrorPoste] = useState(false)
    const [showErrorType, setShowErrorType] = useState(false)
    const [showErrorInstitution, setShowErrorInstitution] = useState(false)
    const [showErrorCatInstitution, setShowErrorCatInstitution] = useState(false)
    const [showErrorRoles, setShowErrorRoles] = useState(false)
    const [showErrorPassword, setShowErrorPassword] = useState(false)
    const [showErrorSexe, setShowErrorSexe] = useState(false)
    const [showErrorIsBcc, setShowErrorIsBcc] = useState(false)

    const [nomErrorMessage, setNomErrorMessage] = useState("")
    const [prenomErrorMessage, setPrenomErrorMessage] = useState("")
    const [emailErrorMessage, setEmailErrorMessage] = useState("")
    const [telephoneErrorMessage, setTelephoneErrorMessage] = useState("")
    const [posteErrorMessage, setPosteErrorMessage] = useState("")
    const [passwordErrorMessage, setPasswordErrorMessage] = useState("")
    const [typeErrorMessage, setTypeErrorMessage] = useState("")
    const [InstitutionErrorMessage, setInstitutionErrorMessage] = useState("")
    const [InstitutionCatErrorMessage, setInstitutionCatErrorMessage] = useState("")
    const [rolesErrorMessage, setRolesErrorMessage] = useState("")
    const [sexeErrorMessage, setSexeErrorMessage] = useState("")
    const [isBccErrorMessage, setIsBccErrorMessage] = useState("")

    const dispatch = useDispatch();

    const states = useSelector((state) => state, shallowEqual);

    const handleChangeEntry = (key, e) => {
        var value = e.currentTarget.value;
        if (key == "nom") {
            setAgent({ ...agent, nom: value });
        }
        if (key == "prenom") {
            setAgent({ ...agent, prenom: value });
        }
        if (key == "telephone") {
            setAgent({ ...agent, telephone: value });
        }
        if (key == "email") {
            setAgent({ ...agent, email: value });
        }
        if (key == "password") {
            setAgent({ ...agent, password: value });
        }
        if (key == "poste") {
            setAgent({ ...agent, poste: value });
        }

        if (key == "role") {
            setAgent({ ...agent, role: value });
        }

    }

    const handleAddAgent = async (type) => {
        setProcessOngoing(true)
        // console.log("Here is agent to add", agent)
        const reqdata = await addAgent(agent, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status === 422) {
                setProcessOngoing(false)
                // console.log(reqdata.response?.data.error["nom"][0].length)
                if (reqdata.response?.data.error.nom) {
                    var errorMsg1 = reqdata.response?.data.error.nom[0];
                    setShowErrorNom(true)
                    setNomErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.prenom) {
                    var errorMsg1 = reqdata.response?.data.error.prenom[0];
                    setShowErrorPrenom(true)
                    setPrenomErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.email) {
                    var errorMsg2 = reqdata.response?.data.error.email[0];
                    setShowErrorEmail(true)
                    setEmailErrorMessage(errorMsg2)
                }
                if (reqdata.response?.data.error.telephone) {
                    var errorMsg3 = reqdata.response?.data.error.telephone[0];
                    setShowErrorTelephone(true)
                    setTelephoneErrorMessage(errorMsg3)
                }
                if (reqdata.response?.data.error.sexe) {
                    var errorMsg3 = reqdata.response?.data.error.sexe[0];
                    setShowErrorSexe(true)
                    setSexeErrorMessage(errorMsg3)
                }
                if (reqdata.response?.data.error.poste) {
                    var errorMsg1 = reqdata.response?.data.error.poste[0];
                    setShowErrorPoste(true)
                    setPosteErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.type_agent) {
                    var errorMsg1 = reqdata.response?.data.error.type_agent[0];
                    setShowErrorType(true)
                    setTypeErrorMessage(errorMsg1)
                }


                if (reqdata.response?.data.error.password) {
                    var errorMsg3 = reqdata.response?.data.error.password[0];
                    setShowErrorPassword(true)
                    setPasswordErrorMessage(errorMsg3)
                }

                if (reqdata.response?.data.error.institution_id) {
                    var errorMsg1 = reqdata.response?.data.error.institution_id[0];
                    setShowErrorInstitution(true)
                    setInstitutionErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.role) {
                    var errorMsg1 = reqdata.response?.data.error.role[0];
                    setShowErrorRoles(true)
                    setRolesErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.isBcc) {
                    var errorMsg1 = reqdata.response?.data.error.isBcc[0];
                    setShowErrorIsBcc(true)
                    setIsBccErrorMessage(errorMsg1)
                }
                if (agent.categorieInstitution.value === "") {
                    var errorMsg1 = "Le champ catégorie d'institution est obligatoire";
                    setShowErrorCatInstitution(true)
                    setInstitutionCatErrorMessage(errorMsg1)
                }
            } else {
                setProcessOngoing(false)
                // console.log(reqdata.response)
                toast.error(reqdata.response?.data.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            // console.log("Here we are")
            toast.success(`Nouvel Agent ${agent.prenom}` + " " + `${agent.nom}` + `${agent.sexe == "F" ? " ajoutée " : " ajouté "}` + " avec succès !", {
                position: toast.POSITION.TOP_RIGHT
            });
            setAgent({ ...agent, nom: "", poste: "", prenom: "", sexe: { label: "", value: "" }, telephone: "", email: "", categorieInstitution: { label: "", value: "" }, institution: { label: "", value: "" }, password: "", type: { label: "", value: "" }, roles: [] })

            let response = await getAgents(states.userToken.access_token, 1, "");
            let response_copy = response.data.data.map(obj => ({ ...obj, showDelete: false }))
            dispatch({
                type: "SET",
                key: "agentList",
                payload: response_copy,
            });
            if (type == "retourner") { navigate("/agent") }

        }
    }

    const handleEditAgent = async () => {
        setProcessOngoing(true)

        const reqdata = await updateAgent(id_agent, agent, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status === 422) {
                setProcessOngoing(false)
                setProcessOngoing(false)
                // console.log(reqdata.response?.data.error)
                if (reqdata.response?.data.error.nom) {
                    var errorMsg1 = reqdata.response?.data.error.nom[0];
                    setShowErrorNom(true)
                    setNomErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.prenom) {
                    var errorMsg1 = reqdata.response?.data.error.prenom[0];
                    setShowErrorPrenom(true)
                    setPrenomErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.email) {
                    var errorMsg2 = reqdata.response?.data.error.email[0];
                    setShowErrorEmail(true)
                    setEmailErrorMessage(errorMsg2)
                }
                if (reqdata.response?.data.error.telephone) {
                    var errorMsg3 = reqdata.response?.data.error.telephone[0];
                    setShowErrorTelephone(true)
                    setTelephoneErrorMessage(errorMsg3)
                }
                if (reqdata.response?.data.error.sexe) {
                    var errorMsg3 = reqdata.response?.data.error.sexe[0];
                    setShowErrorSexe(true)
                    setSexeErrorMessage(errorMsg3)
                }
                if (reqdata.response?.data.error.poste) {
                    var errorMsg1 = reqdata.response?.data.error.poste[0];
                    setShowErrorPoste(true)
                    setPosteErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.type_agent) {
                    var errorMsg1 = reqdata.response?.data.error.type_agent[0];
                    setShowErrorType(true)
                    setTypeErrorMessage(errorMsg1)
                }


                if (reqdata.response?.data.error.password) {
                    var errorMsg3 = reqdata.response?.data.error.password[0];
                    setShowErrorPassword(true)
                    setPasswordErrorMessage(errorMsg3)
                }

                if (reqdata.response?.data.error.institution_id) {
                    var errorMsg1 = reqdata.response?.data.error.institution_id[0];
                    setShowErrorInstitution(true)
                    setInstitutionErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.role) {
                    var errorMsg1 = reqdata.response?.data.error.role[0];
                    setShowErrorRoles(true)
                    setRolesErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.isBcc) {
                    var errorMsg1 = reqdata.response?.data.error.isBcc[0];
                    setShowErrorIsBcc(true)
                    setIsBccErrorMessage(errorMsg1)
                }
                if (agent.categorieInstitution.value === "") {
                    var errorMsg1 = "Le champ catégorie d'institution est obligatoire";
                    setShowErrorCatInstitution(true)
                    setInstitutionCatErrorMessage(errorMsg1)
                }

            } else {
                setProcessOngoing(false)
                // console.log(reqdata.response)
                toast.error(reqdata.response?.data.error, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            toast.success(`Modification éffectuée !`, {
                position: toast.POSITION.TOP_RIGHT
            });
            navigate("/agent")
        }
    }

    const handleBack = () => {
        navigate("/agent")
    }


    useEffect(() => {
        if (agent.nom != "") {
            setShowErrorNom(false)
        }
        if (agent.prenom != "") {
            setShowErrorPrenom(false)
        }
        if (agent.poste != "") {
            setShowErrorPoste(false)
        }
        if (agent.email != "") {
            setShowErrorEmail(false)
        }
        if (agent.telephone != "") {
            setShowErrorTelephone(false)
        }
        if (agent.password != "") {
            setShowErrorPassword(false)
        }
        if (agent.sexe.value != "") {
            setShowErrorSexe(false)
        }
        if (agent.type.value != "") {
            setShowErrorType(false)
        }
        if (agent.isBCC.value != "") {
            setShowErrorIsBcc(false)
        }
        if (agent.institution.value != "") {
            setShowErrorInstitution(false)
        }
        if (agent.categorieInstitution.value != "") {
            setShowErrorCatInstitution(false)
        }
        if (agent.roles?.length != 0) {
            setShowErrorRoles(false)
        }
    }, [agent])
    const customStyles2 = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '35px',
            //   height: '35px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            padding: '0 6px',
            //   marginTop: '-5px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
            //   height: '30px'
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            minHeight: '35px',
        }),
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '35px',
            height: '35px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '35px',
            padding: '0 6px',
            marginTop: '-5px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
            //   height: '30px'
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '35px',
        }),
    };
    let array = []
    const roleSelection = (e) => {
        let values = []
        e.map(a => values.push({ value: a.value, label: a.label }));
        // console.log("values", typeof values)
        console.log(values)

        setAgent({ ...agent, roles: values })
    }

    const selection = (e, key) => {
        if (key == "institution") {
            setAgent({ ...agent, institution: { value: e.value, label: e.label } })
        }
        if (key == "institution-category") {
            setAgent({ ...agent, categorieInstitution: { value: e.value, label: e.label } })
        }
        if (key == "type") {
            setAgent({ ...agent, type: { value: e.value, label: e.label } })
        }
        if (key == "sexe") {
            setAgent({ ...agent, sexe: { value: e.value, label: e.label } })
        } if (key == "isBCC") {
            setAgent({ ...agent, isBCC: { value: e.value, label: e.label } })
        }
    }

    useEffect(() => {
        loadAgentData();
        loadInstitutionCategories();
        // loadInstitutions(agent.categorieInstitution);
        loadRoles();
    }, [])

useEffect(() => {
    let temp = [];
    console.log("instit category ", agent.categorieInstitution)
    console.log("roles category ", roles)
    if(agent.categorieInstitution.label !== "Autres Etablissements") {

        temp = roles.filter(item => item.value != 1 && item.value != 2 )
        console.log("temp 1", temp)
        setRoles(temp)
    } else {
        console.log("temp 2", temp)
        temp = [...rolesCopy];
        // temp = rolesCopy.filter(item => item.value == 1 && item.value == 2 )
        setRoles(temp)
    }
}, [agent.categorieInstitution]);

    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    {displayLoader == false ?
                        <div className="layout-px-spacing">

                            <div className="row layout-top-spacing">
                                <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                                </div>
                            </div>
                            <div className="w-90">
                                <h4 className="modal-title text-left " id="exampleModalLabel">{operationType == "new" ? "Nouvel Agent" : "Modifier Agent"}</h4>
                            </div>
                            <div className="widget widget-content widget-content-area mt-3 pt-3">
                                <div className="pl-3 mx-auto">
                                    <h5 className="modal-title py-2 mb-1 text-left " id="exampleModalLabel">{"Informations Personnelles"}</h5>
                                </div>
                                <hr />
                                <div className="w-90 mx-auto">
                                    {/* Name and Firstname */}
                                    <div className="d-flex">
                                        <div className="col-6 px-0">
                                            <div class="form-group row mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Nom</label>
                                                <div class="col-sm-8">
                                                    <input type="text" onChange={(e) => handleChangeEntry("nom", e)} className={showErrorNom == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "custom-form-control form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={agent.nom} required />
                                                    {showErrorNom === true && <span className="new-agent-error-span">{nomErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6 px-0">
                                            <div class="form-group row  mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Prénom</label>
                                                <div class="col-sm-8">
                                                    <input type="text" onChange={(e) => handleChangeEntry("prenom", e)} className={showErrorPrenom == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={agent.prenom} required />
                                                    {showErrorPrenom === true && <span className="new-agent-error-span">{prenomErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Postname and Sex */}

                                    <div className="d-flex">

                                        <div className="col-6 px-0 mb-2">
                                            <div class="form-group row ">
                                                <label for="password" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Mot de passe</label>
                                                <div class="col-sm-8">

                                                    <div class="input-group"
                                                        className={showErrorPassword == true ? "input-group new-institution-error-input" : "input-group"}
                                                    >
                                                        <input type={showPassword === true ? "text" : "password"} disabled={operationType === "new" ? false : true}
                                                            placeholder=""
                                                            className={"form-control custom-form-control form-control-sm mx-auto pwd-input-focus"}
                                                            onChange={(e) => handleChangeEntry("password", e)}
                                                            value={agent.password}
                                                            style={{ borderRadius: operationType !== "new" && "8px" }} />
                                                        <div class="input-group-append" >
                                                            {operationType === "new" && <span class="input-group-text" id="basic-addon2">
                                                                {showPassword === false && <AiFillEyeInvisible style={{ cursor: "pointer" }} onClick={handleDisplayPassword} />}
                                                                {showPassword === true && <FiEye style={{ cursor: "pointer" }} onClick={handleDisplayPassword} />}
                                                            </span>}
                                                        </div>
                                                    </div>
                                                    {/* <input type="password" disabled={operationType === "new" ? false : true} onChange={(e) => handleChangeEntry("password", e)} className={showErrorPassword == true ? "form-control form-control-sm new-institution-error-input  mx-auto" : "form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={agent.password} required /> */}
                                                    {showErrorPassword === true && <span className="new-institution-error-span">{passwordErrorMessage}</span>}
                                               
                                               
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-6 px-0 mb-2">
                                            <div class="form-group row ">
                                                <label for="category" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Sexe</label>
                                                <div class="col-sm-8">
                                                    <Select
                                                        onChange={(e) => selection(e, "sexe")}
                                                        placeholder=""
                                                        className={showErrorSexe == true ? "new-institution-error-input " : ""}
                                                        classNamePrefix="select"
                                                        value={agent.sexe.label !== "" ? agent.sexe : ""}
                                                        isDisabled={false}
                                                        isLoading={false}
                                                        isClearable={true}
                                                        isRtl={false}
                                                        // isSearchable={true}
                                                        name="agent-sexe"
                                                        options={sexAgent}
                                                        styles={customStyles}
                                                    />

                                                    {showErrorSexe === true && <span className="new-product-error-span">{sexeErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Phone and email */}
                                    <div className="d-flex">
                                        <div className="col-6 px-0">
                                            <div class="form-group row mb-2">
                                                <label for="telephone" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Téléphone(<span style={{color: "red"}}>sans indicatif</span>)</label>
                                                <div class="col-sm-8">
                                                    <input type="tel" onChange={(e) => handleChangeEntry("telephone", e)} className={showErrorTelephone == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "custom-form-control form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={agent.telephone} required />
                                                    {showErrorTelephone === true && <span className="new-agent-error-span">{telephoneErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6 px-0">
                                            <div class="form-group row mb-2">
                                                <label for="email" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Email</label>
                                                <div class="col-sm-8">
                                                    <input type="email" onChange={(e) => handleChangeEntry("email", e)} className={showErrorEmail == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={agent.email} required />
                                                    {showErrorEmail === true && <span className="new-agent-error-span">{emailErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row my-3"></div>

                            </div>

                            <div className="widget widget-content widget-content-area mt-3 pt-3">
                                <div className="pl-3 mx-auto">
                                    <h5 className="modal-title py-2 mb-1 text-left " id="exampleModalLabel">{"Informations Professionnelles"}</h5>
                                </div>
                                <hr />
                                <div className="w-90 mx-auto">

                                    {/* Postname and Sex */}

                                    <div className="d-flex">
                                        <div className="col-6 px-0">
                                            <div class="form-group row  mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Poste</label>
                                                <div class="col-sm-8">
                                                    <input type="text" onChange={(e) => handleChangeEntry("poste", e)} className={showErrorPoste == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={agent.poste} />
                                                    {showErrorPoste === true && <span className="new-agent-error-span">{posteErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-6 px-0">
                                            <div class="form-group row mb-4">
                                                <label for="category" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Type</label>
                                                <div class="col-sm-8">
                                                    {/*  */}
                                                    <Select
                                                        onChange={(e) => selection(e, "type")}
                                                        placeholder=""
                                                        className={showErrorType == true ? "new-institution-error-input " : ""}
                                                        classNamePrefix="select"
                                                        value={agent.type.label !== "" ? agent.type : ""}
                                                        isDisabled={false}
                                                        isLoading={false}
                                                        isClearable={false}
                                                        isRtl={false}
                                                        isSearchable={false}
                                                        name="agent-type"
                                                        options={typeAgent}
                                                        styles={customStyles}
                                                    />
                                                    {/*  */}
                                                    {showErrorType === true && <span className="new-product-error-span">{typeErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Institution */}
                                    <div className="d-flex">
                                        <div className="col-6 px-0">
                                            <div class="form-group row  mb-4">
                                                <label for="category" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Catégorie d'institution</label>
                                                <div class="col-sm-8">
                                                    {/*  */}
                                                    <Select
                                                        onChange={(e) => selection(e, "institution-category")}
                                                        placeholder=""
                                                        className={showErrorCatInstitution == true ? "new-institution-error-input " : ""}
                                                        classNamePrefix="select"
                                                        value={agent.categorieInstitution.label !== "" ? agent.categorieInstitution : ""}
                                                        isDisabled={false}
                                                        isLoading={false}
                                                        isClearable={true}
                                                        isRtl={false}
                                                        isSearchable={true}
                                                        name="agent-institution-category"
                                                        options={institutionCategories}
                                                        styles={customStyles}
                                                    />
                                                    {/*  */}
                                                    {showErrorCatInstitution === true && <span className="new-product-error-span">{InstitutionCatErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6 px-0">
                                            <div class="form-group row mb-4">
                                                <label for="category" class="col-sm-4 col-form-label col-form-label-sm text-dark required">Institution</label>
                                                <div class="col-sm-8">
                                                    {/*  */}
                                                    <Select
                                                        onChange={(e) => selection(e, "institution")}
                                                        placeholder=""
                                                        className={showErrorInstitution == true ? "new-institution-error-input " : ""}
                                                        classNamePrefix="select"
                                                        value={agent.institution.label !== "" ? agent.institution : ""}
                                                        isDisabled={false}
                                                        isLoading={false}
                                                        isClearable={true}
                                                        isRtl={false}
                                                        name="agent-institution"
                                                        options={institutionsOfCategory}
                                                        styles={customStyles}
                                                    />
                                                    {/*  */}
                                                    {showErrorInstitution === true && <span className="new-product-error-span">{InstitutionErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    {/* <div className="d-flex">

                                    <div className="col-6">
                                        <div class="form-group row mb-4">
                                            <label for="role" class="col-sm-3 col-form-label col-form-label-sm text-dark required">BCC</label>
                                            <div class="col-sm-9 role-select-custom">
                                                <Select
                                                    onChange={(e) => selection(e, "isBCC")}
                                                    value={agent.isBCC.label !== "" ? agent.isBCC : ""}
                                                    placeholder=""
                                                    name="roles"
                                                    options={isBCC}
                                                    className={showErrorIsBcc == true ? "new-institution-error-input " : ""}
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                />
                                                {showErrorIsBcc === true && <span className="new-institution-error-span">{isBccErrorMessage}</span>}
                                            </div>

                                        </div>
                                    </div>
                                    
                                </div> */}

                                    <div className="d-flex">
                                        <div className="col-12 px-0">
                                            <div class="form-group row mb-4">
                                                <label for="role" class="col-sm-2 col-form-label col-form-label-sm text-dark required">Rôle</label>
                                                <div class="col-sm-10 role-select-custom">
                                                    <Select
                                                        onChange={roleSelection}
                                                        value={agent.roles}
                                                        placeholder=""
                                                        isMulti
                                                        name="roles"
                                                        options={roles}
                                                        className={showErrorRoles == true ? "new-institution-error-input " : ""}
                                                        classNamePrefix="select"
                                                        styles={customStyles2}
                                                    />
                                                    {showErrorRoles === true && <span className="new-institution-error-span">{rolesErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </div>
                                <div className="row my-3"></div>
                            </div>
                            <div className="new-agent-custom-modal-footer pb-3">
                                {processOngoing == false ? <Fragment>
                                    <button type="button"
                                        title={operationType == "new" ? "Ajouter et rester sur la page" : "Modifier"}
                                        className="btn btn-primary ml-3" onClick={operationType == "new" ? () => handleAddAgent("rester") : handleEditAgent}>{operationType == "new" ? "Ajouter et Nouveau" : "Modifier"}</button>
                                    {operationType == "new" &&
                                        <button type="button"
                                            title={"Ajouter et retourner à la liste"}
                                            className="btn btn-primary ml-3"
                                            onClick={() => handleAddAgent("retourner")}>
                                            Ajouter et Retourner</button>
                                    }
                                </Fragment> : <ProcessSpinner />}
                                <button className="btn ml-3" data-dismiss="modal" onClick={handleBack}><i className="flaticon-cancel-12"></i> Retour</button>
                            </div>

                        </div> : <div style={{ marginTop: "25%" }}>
                            <Loader />
                        </div>}

                </div>
            </div>
        </div>



    )
}

export default AddOrEditAgent

